var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6986 31.4563L23.6986 31.4563L23.6935 31.4579C23.4339 31.5397 23.128 31.5022 22.8658 31.3455L22.8518 31.3371L22.8372 31.3297L12.7122 26.1459L12.4846 26.0293L12.2568 26.1458L2.11617 31.3296L2.1161 31.3294L2.10519 31.3354C1.92996 31.4305 1.74427 31.4828 1.57812 31.4828C0.996674 31.4828 0.5 30.9884 0.5 30.3508V6.06377C0.5 4.04018 1.28841 2.68178 2.53307 1.80939C3.80414 0.91849 5.60275 0.5 7.65625 0.5H17.2969C19.3582 0.5 21.1571 0.918484 22.4323 1.80977C23.6813 2.68273 24.4775 4.04235 24.5 6.06653V30.3508C24.5 30.5471 24.4548 30.7386 24.3698 30.9024C24.228 31.1695 23.9905 31.3677 23.6986 31.4563ZM18.3594 9.16363H6.59375C5.63055 9.16363 4.875 9.9629 4.875 10.9276C4.875 11.8902 5.63014 12.6915 6.59375 12.6915H18.3594C19.323 12.6915 20.0781 11.8902 20.0781 10.9276C20.0781 9.9629 19.3226 9.16363 18.3594 9.16363Z",
    fill: "white",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveicon);
export default __webpack_public_path__ + "static/media/save icon.d4f83cc95dbedb140950e05d932fd8f6.svg";
export { ForwardRef as ReactComponent };